import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
const CarePlanTableDetails = ({ extractor }) => {
    const { t } = useTranslation();
    const { asString } = extractor;
    return (_jsxs(_Fragment, { children: [asString.description, asString.description && asString.notes && _jsx("br", {}), asString.notes && (_jsxs(_Fragment, { children: [' ', t('ps.event_viewer.note:'), " ", asString.notes] }))] }));
};
export default CarePlanTableDetails;
